import { ExternalLink } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { usePreferenciaAutosEmNovaAba } from '@/hooks/useAbrirAutos';

/**
 * Configurações → "Abrir os autos sempre em nova aba" (docs/PLANO_BANCADA.md, Bloco 2).
 * Desligada por padrão: a aba nova é fácil de pedir (Ctrl+clique, botão do meio) e
 * nunca imposta. Quem trabalha em vários processos ao mesmo tempo liga aqui.
 */
export function AutosEmNovaAbaCard() {
  const [sempre, setSempre] = usePreferenciaAutosEmNovaAba();
  return (
    <Card className="border bg-card">
      <CardContent className="pt-6">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <ExternalLink className="h-5 w-5 text-primary" />
            <p className="text-base font-semibold">Autos</p>
          </div>
          <div className="flex items-start justify-between gap-4">
            <div className="space-y-1">
              <Label htmlFor="autos-nova-aba" className="text-sm font-medium">
                Abrir os autos sempre em nova aba
              </Label>
              <p className="text-sm text-muted-foreground">
                Cada processo abre numa aba própria, sem o menu, e clicar de novo no mesmo processo
                volta à aba dele. Vale no computador; no celular e no app instalado os autos abrem
                na mesma tela.
              </p>
              <p className="text-sm text-muted-foreground">
                Sem ligar, Ctrl+clique (⌘ no Mac) ou o botão do meio do mouse fazem isso quando você
                quiser.
              </p>
            </div>
            <Switch
              id="autos-nova-aba"
              checked={sempre}
              onCheckedChange={setSempre}
              className="mt-0.5 shrink-0"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
